import { render, staticRenderFns } from "./PreparationLimitSettingList.vue?vue&type=template&id=d00b8472"
import script from "./PreparationLimitSettingList.vue?vue&type=script&lang=ts"
export * from "./PreparationLimitSettingList.vue?vue&type=script&lang=ts"
import style0 from "./PreparationLimitSettingList.vue?vue&type=style&index=0&id=d00b8472&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports